import { useEffect } from "react";

export const useHideTabBar = () => {
    useEffect(() => {
        const tabsElem =
            document.querySelector<HTMLDivElement>(".fund-centre-tabs");
        if (tabsElem) {
            if (!tabsElem.classList.contains("hidden"))
                tabsElem.classList.add("hidden");
            return () => {
                tabsElem.classList.remove("hidden");
            };
        }
    }, []);
};
